<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-snackbar v-model="ok_snackbar" :timeout="3000" color="green darken-3 white--text" :top="true">
        {{ ok_text }}
        <v-btn color="white" flat @click="ok_snackbar = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
      <v-snackbar v-model="error_snackbar" :timeout="3000" color="red darken-3 white--text" :top="true">
        {{ error_text }}
        <v-btn color="white" flat @click="error_snackbar = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
      <v-dialog
        v-model="dialogSeriovaCisla"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogSeriovaCisla"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Sériová čísla</h2>
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            <v-data-table
              :headers="seriovaCislaHeaders"
              :items="seriova_cisla"
              hide-actions
              class="mt-3 elevation-1 mb-3"
              color="transparent"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <v-text-field
                    v-model="props.item.cislo"
                    @input="inputSerioveCislo(props.item)"
                  ></v-text-field>
                </td>
                <td class="text-xs-right">
                  <v-btn color="red" class="mr-0" fab flat @click="removeClick(props.item)"><v-icon>delete</v-icon></v-btn>
                </td>
              </template>
            </v-data-table>
            <p class="subheading mt-4">Přidat sériová čísla hromadně:</p>
            <v-card color="grey lighten-3">
              <v-card-text class="pl-2 pr-2 pt-0 pb-0">
                <v-form lazy-validation v-model="seriova_cisla_valid" ref="seriova_cisla_form">
                  <v-layout row wrap>
                    <v-flex xs12 sm4>
                      <v-text-field
                        label="Číslo od"
                        class="mx-2"
                        v-model="seriova_cisla_hromadne_od"
                        @input="() => { seriova_cisla_hromadne_do = seriova_cisla_hromadne_od.toString(); }"
                        :rules="seriova_cisla_hromadne_od_rules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <v-text-field
                        label="Číslo do"
                        v-model="seriova_cisla_hromadne_do"
                        class="mx-2"
                        :rules="seriova_cisla_hromadne_do_rules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <v-btn color="primary" small depressed class="mt-3 ml-3" @click="hromadnaSeriovaCislaClick">Přidat</v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red elevation-0" dark @click="saveSeriovaCisla"><v-icon class="mr-2">save</v-icon>Uložit</v-btn>
            <v-btn color="grey elevation-0 lighten-3" @click="dialogSeriovaCisla=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1 page-elevation page-card">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="custom-scrollbar">
          <h2 class="mx-3 mt-2">Příjemky k obj. č. {{objednavka.cislo_objednavky}}</h2>
          <v-layout row wrap>
            <v-flex xs12 sm7 md6>
              <div class="mx-3">
                <v-card class="no__radius grey lighten-4 mt-3" v-for="prijemka in prijemky" :key="'prijemka-'+prijemka.id.toString()">
                  <v-card-text>
                    <v-layout row d-flex class="align-center">
                      <v-flex class="fill-width">
                        <h3 class="mt-2 mb-2 mx-3">Příjemka ze dne {{prijemka.datum | formatSimpleDate}}</h3>
                      </v-flex>
                      <!--<v-flex v-if="!prijemka.edit">
                        <v-btn color="primary" flat small @click="prijemka.edit=true" class="right"><v-icon small class="mr-2">edit</v-icon> Upravit</v-btn>
                      </v-flex>-->
                    </v-layout>
                    <v-layout row wrap class="mt-2" v-if="prijemka.edit">
                      <v-flex xs6 sm6 md6 lg4>
                        <datepicker label="Datum příjemky" v-model="prijemka.datum" :rules="true" class="mx-3"></datepicker>
                      </v-flex>
                    </v-layout>
                    <v-data-table
                      :headers="produktyPrijemHistoriekaHeaders"
                      :items="prijemka.produkty"
                      hide-actions
                      class="mx-2 mt-3"
                      color="transparent"
                    >
                      <template slot="items" slot-scope="props">
                        <td>
                          <router-link :to="{ path: '/produkty/' + props.item.id }" target="_blank">
                            {{ props.item.nazev }}
                          </router-link>
                        </td>
                        <td class="text-xs-right">
                          <span v-if="!prijemka.edit">{{props.item.dodane_mnozstvi}} ks</span>
                          <v-text-field v-else reverse class="right" style="max-width: 100px" suffix="ks" v-model="props.item.dodane_mnozstvi"></v-text-field>
                        </td>
                        <td>
                          <div v-if="props.item.vyzadovat_seriove_cislo">
                            <span v-for="(sc, i) in props.item.seriova_cisla" :key="'produkt-'+props.item.id.toString()+'-sc-'+i.toString()"><span v-if="i>0">, </span>{{sc.seriove_cislo}}</span>
                          </div>
                        </td>
                      </template>
                    </v-data-table>
                    <v-layout row wrap class="mt-2" v-if="prijemka.edit">
                      <v-flex>
                        <div class="mr-1 mt-2 mb-2">
                          <v-btn color="green" class="right mr-3" depressed dark @click="save(prijemka)" :loading="prijemka.saving">Uložit příjemku</v-btn>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
                <v-form lazy-validation v-model="valid" ref="form">
                  <v-card class="no__radius grey lighten-4 mt-3">
                    <v-card-text>
                      <h3 class="mt-3 mx-3">Nová příjemka:</h3>
                      <v-layout row wrap class="mt-2">
                        <v-flex xs6 sm6 md6 lg4>
                          <datepicker label="Datum příjemky" v-model="prijemka_datum" :rules="true" class="mx-3"></datepicker>
                        </v-flex>
                      </v-layout>
                      <h4 class="mt-2 mx-3">Přijaté produkty</h4>
                      <v-data-table
                        :headers="produktyPrijemkaHeaders"
                        :items="nova_prijemka_produkty"
                        hide-actions
                        class="mx-2 mt-3"
                        color="transparent"
                        :expand="true"
                        ref="novaPrijemkaTable"
                        item-key="row_id"
                      >
                        <template slot="items" slot-scope="props">
                          <td>
                            <router-link :to="{ path: '/produkty/' + props.item.id }" target="_blank" v-if="props.item.typ=='produkt'">
                              {{ props.item.produkt.nazev }}
                            </router-link>
                            <span v-else>Metal konto - {{props.item.material.nazev}}</span>
                          </td>
                          <td class="text-xs-right">
                            <span v-if="props.item.typ=='produkt'">{{props.item.mnozstvi}} ks</span>
                            <span v-else>{{props.item.mnozstvi | formatMoney}} g</span>
                          </td>
                          <td class="text-xs-right">
                            <v-layout row :class="{ 'mb-4': props.item.dodane_mnozstvi <= props.item.mnozstvi }">
                              <v-flex>
                                <v-text-field reverse class="right" hide-details style="max-width: 100px" suffix="ks" type="number" v-model="props.item.dodane_mnozstvi"></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap class="mt-2 mb-2" v-if="props.item.dodane_mnozstvi > props.item.mnozstvi">
                              <v-flex>
                                <span class="red--text">Dodané množství<br />je větší než očekávané.</span>
                              </v-flex>
                            </v-layout>
                          </td>
                          <td>
                            <v-btn color="primary" depressed small @click="seriovaCislaClick(props.item)" v-if="parseInt(props.item.dodane_mnozstvi) > 0 && props.item.produkt.vyzadovat_seriove_cislo">Sériová čísla</v-btn>
                          </td>
                        </template>
                        <template slot="expand" slot-scope="props">
                          <v-card class="grey lighten-4 mt-3 ml-3 mb-4 mr-4 no__radius" v-if="props.item.produkt.vyzadovat_seriove_cislo">
                            <v-card-text>
                              <p class="ml-1 mr-1 mt-1 mb-0 subheading darken-3">Sériová čísla pro {{props.item.produkt.nazev}}:</p>
                              <p class="ml-1 mr-1 mt-1 mb-0 subheading darken-3">
                                <span v-for="(sc, i) in props.item.seriova_cisla" :key="'produkt-'+props.item.id.toString()+'-sc-'+i.toString()"><span v-if="i>0">, </span>{{sc}}</span>
                              </p>
                            </v-card-text>
                          </v-card>
                        </template>
                      </v-data-table>
                      <v-layout row wrap class="mt-2">
                        <v-flex>
                          <div class="mr-1 mt-2 mb-2">
                            <v-btn color="green" class="right mr-3" depressed dark @click="create" :loading="saving">Uložit příjemku</v-btn>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-form>
              </div>
            </v-flex>
            <v-flex xs12 sm5 md6>
              <div class="gui-flex gui-flex-rows mx-3">
                <v-card class="no__radius grey lighten-4 mt-3">
                  <v-card-text>
                    <h3 class="mt-3 mx-3">Faktura dodavatele</h3>
                    <v-layout row wrap class="mt-3">
                      <v-flex xs12 sm4 md3>
                        <div class="mx-3">
                          <p class="caption mb-1">Číslo faktury dodavatele:</p>
                          <p><strong>{{fa_cislo}}</strong></p>
                        </div>
                      </v-flex>
                      <v-flex xs12 sm4 md3>
                        <div class="mx-3">
                          <p class="caption mb-1">Datum vystavení:</p>
                          <p><strong>{{fa_datum_vystaveni | formatSimpleDate}}</strong></p>
                        </div>
                      </v-flex>
                      <v-flex xs12 sm4 md3>
                        <div class="mx-3">
                          <p class="caption mb-1">Měna:</p>
                          <p><strong>{{mena.nazev}}</strong></p>
                        </div>
                      </v-flex>
                    </v-layout>
                    <h4 class="mt-4 mx-3">Položky faktury</h4>
                    <v-data-table
                      :headers="produktyHeaders"
                      :items="objednavka.produkty"
                      hide-actions
                      class="mx-2 mt-3"
                      color="transparent"
                    >
                      <template slot="items" slot-scope="props">
                        <td>
                          <router-link :to="{ path: '/produkty/' + props.item.id }" target="_blank" v-if="props.item.typ=='produkt'">
                            {{ props.item.produkt.nazev }}
                          </router-link>
                          <span v-else>Metal konto - {{props.item.material.nazev}}</span>
                        </td>
                        <td class="text-xs-right">
                          <span v-if="props.item.typ=='produkt'">{{props.item.mnozstvi}} ks</span>
                          <span v-else>{{props.item.mnozstvi | formatMoney}} g</span>
                        </td>
                        <td class="text-xs-right">
                          {{props.item.cena_mj | formatMoney}} {{mena.zkratka}}
                        </td>
                        <td class="text-xs-right">
                          {{props.item.cena_celkem | formatMoney}} {{mena.zkratka}}
                        </td>
                      </template>
                      <template slot="footer">
                        <tr>
                          <td colspan="3"><strong>Celková částka:</strong></td>
                          <td>
                            <div class="mt-4 mb-4 text-xs-right">
                              <strong>{{total | formatMoney}} EUR</strong>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                    <v-flex xs12 class="mt-3 right">
                      <div class="mr-4 pr-2">
                        <p class="caption mb-1 text-xs-right">Cena dopravy:</p>
                        <p class="text-xs-right"><strong>{{cena_dopravy}} {{mena.zkratka}}</strong></p>
                      </div>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      produktyHeaders: [
        { text: 'Produkt', value: 'cilovy_produkt', sortable: false, width: "300px" },
        { text: 'Množství', value: 'mnozstvi', sortable: false, width: "180px", align: "right" },
        { text: 'Nákupní cena za MJ', value: 'nakupni_cena_mj', sortable: false, width: "180px", align: "right" },
        { text: 'Nákupní cena celková', value: 'nakupni_cena_celkem', sortable: false, width: "180px", align: "right" }
      ],
      produktyPrijemkaHeaders: [
        { text: 'Produkt', value: 'cilovy_produkt', sortable: false, width: "300px" },
        { text: 'Očekávané množství', value: 'mnozstvi', sortable: false, width: "220px", align: "right" },
        { text: 'Dodané množství', value: 'nakupni_cena_mj', sortable: false, width: "220px", align: "right" },
        { text: '', value: 'id', sortable: false, align: "right" }
      ],
      produktyPrijemHistoriekaHeaders: [
        { text: 'Produkt', value: 'cilovy_produkt', sortable: false, width: "300px" },
        { text: 'Dodané množství', value: 'nakupni_cena_mj', sortable: false, width: "220px", align: "right" },
        { text: 'Sériová čísla', value: 'seriova_cisla', sortable: false, align: "left" }
      ],
      seriovaCislaHeaders: [
        { text: 'Sériové číslo', value: 'cislo', sortable: false },
        { text: 'Akce', value: '', sortable: false, width: "120px", align: "right" }
      ],
      objednavka: null,
      faktura: null,
      fa_cislo: null,
      fa_datum_vystaveni: null,
      mena_id: null,
      mena: null,
      valid: false,
      rulesRequired: [ (v) => !!v || "Pole je vyžadováno" ],
      cena_dopravy: null,
      problem: null,
      dialog: false,
      aktualni_stav: null,
      nova_prijemka_produkty: [],
      prijemka_datum: null,
      saving: false,
      prijemky: [],
      total: 0,
      dialogSeriovaCisla: false,
      produktItem: null,
      seriova_cisla: [],
      seriova_cisla_valid: true,
      seriova_cisla_hromadne_od: null,
      seriova_cisla_hromadne_do: null,
      seriova_cisla_hromadne_od_rules: [
        (v) => {
          if (isNaN(this.seriova_cisla_hromadne_od))
            return "Nebylo zadáno číslo"
          return true;
        }
      ],
      seriova_cisla_hromadne_do_rules: [
        (v) => {
          if (isNaN(this.seriova_cisla_hromadne_do))
            return "Nebylo zadáno číslo"
          if (!isNaN(this.seriova_cisla_hromadne_od)) {
            var _od = parseInt(this.seriova_cisla_hromadne_od);
            var _do = parseInt(this.seriova_cisla_hromadne_do);
            var _dm = parseInt(this.produktItem.dodane_mnozstvi);
            var c = _do - _od;
            if (c < 0)
              return "Nelze přidat méně čísel než 0";
            else if (c > 50)
              return "Nelze přidat více než 50 čísel";
            else if (c + this.seriova_cisla.length > _dm)
              return "Nelze přidat více sériových čísel než je dodaných produktů";
          }
          return true;
        }
      ]
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.prijemka_datum = parseInt(new Date().getTime() / 1000);
    this.load();
  },
  watch: {
    produkty: {
      handler (v) {
        this.resolve();
      },
      deep: true
    }
  },
  props: {
    id: String
  },
  methods: {
    load: function() {
      window.API.get("dodavatele/objednavky/" + this.$props.id + "/faktura-pro-prijemky").then(function(b) {
        this.objednavka = b.objednavka;
        this.faktura = b.faktura;
        var _id = 0;
        this.nova_prijemka_produkty = window.th.copy(b.objednavka.produkty).filter((e) => { return e.typ == 'produkt'; }).map((e) => {
          var local_row_id = _id++;
          e.row_id = "np-" + local_row_id.toString();
          e.dodane_mnozstvi = null;
          e.vetsi_nez_ocekavane = false;
          e.seriova_cisla = []
          return e;
        });
        this.mena = b.mena;
        this.mena_id = b.mena.id;
        if (b.faktura != null) {
          this.mena_id = this.faktura.mena_id;
          this.fa_cislo = this.faktura.dodavatel_fa_cislo;
          this.fa_datum_vystaveni = this.faktura.dodavatel_fa_vystaveni;
          this.cena_dopravy = this.faktura.doprava_cena;
        }
        this.loadPrijemky(() => {
          this.$nextTick(() => {
            for (let i = 0; i < this.nova_prijemka_produkty.length; i += 1) {
                const item = this.nova_prijemka_produkty[i];
                if (item.typ == "produkt")
                  this.$set(this.$refs.novaPrijemkaTable.expanded, item.row_id, true);
            }
          });
        });
        this.computeTotal();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    loadPrijemky (f) {
      window.API.get("dodavatele/objednavky/" + this.$props.id + "/prijemky").then(function(b) {
        this.prijemky = b.map((e) => {
          e.edit = false;
          e.saving = false;
          return e;
        });
        this.loading = false;
        this.saving = false;
        if (typeof f == "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    create () {
      if (this.$refs.form.validate()) {
        if (this.nova_prijemka_produkty.filter((v) => {
          if (!v.produkt.vyzadovat_seriove_cislo)
            return false;
          var _dm = v.typ == 'produkt' && !isNaN(v.dodane_mnozstvi) ? parseInt(v.dodane_mnozstvi) : 0;
          if (_dm > 0) {
            if (_dm != v.seriova_cisla.length)
              return true;
          }
        }).length > 0) {
          this.error("Je třeba upravit sériová čísla slitků.")
        }
        else {
          this.saving = true;
          window.API.post("dodavatele/objednavky/" + this.$props.id + "/prijemky", {
            datum: this.prijemka_datum,
            produkty: this.nova_prijemka_produkty.map((e) => {
              return {
                id: e.id,
                dodane_mnozstvi: e.dodane_mnozstvi,
                objednavka_polozka_id: e.objednavka_polozka_id,
                seriova_cisla: e.seriova_cisla
              };
            })
          }).then((b) => {
            if (b.success) {
              this.load();
              for (var $i = 0; $i < this.nova_prijemka_produkty.length; $i++) {
                this.nova_prijemka_produkty[$i].dodane_mnozstvi = null;
              }
              this.prijemka_datum = parseInt(new Date().getTime() / 1000);
            }
            else {
              this.saving = false;
            }
          }).catch((e) => {

            console.log(e);
          })
        }
      }
    },
    save (prijemka) {

      prijemka.saving = true;
      window.API.put("dodavatele/objednavky/" + this.$props.id + "/prijemky/" + prijemka.id, {
        datum: prijemka.datum,
        produkty: prijemka.produkty.map((e) => {
          return {
            id: e.id,
            dodane_mnozstvi: e.dodane_mnozstvi,
            prijemka_produkt_id: e.prijemka_produkt_id,
            objednavka_polozka_id: e.objednavka_polozka_id,
            seriova_cisla: e.seriova_cisla
          };
        })
      }).then((b) => {
        if (b.success) {
          prijemka.saving = false;
          prijemka.edit = false;
          this.load();
        }
        else {

        }
      }).catch((e) => {

        console.log(e);
      })
    },
    computeTotal () {
      var $total = 0;
      this.objednavka.produkty.forEach((e) => {
        if (e.cena_celkem != null && e.cena_celkem.toString().length > 0 && parseFloat(e.cena_celkem) >= 0)
          $total += parseFloat(e.cena_celkem);
      });
      this.total = $total;
    },
    seriovaCislaClick (produkt) {
      this.produktItem = produkt;
      this.seriova_cisla = window.th.copy(produkt.seriova_cisla).map((e) => {
        return {
          cislo: e
        };
      });
      var $dodane_mnozstvi = parseInt(this.produktItem.dodane_mnozstvi);
      if ($dodane_mnozstvi > this.seriova_cisla.length)
        this.seriova_cisla.push({
          cislo: ""
        });
      this.seriova_cisla_hromadne_od = null;
      this.seriova_cisla_hromadne_do = null;
      this.dialogSeriovaCisla = true;
    },
    hromadnaSeriovaCislaClick () {
      if (this.$refs.seriova_cisla_form.validate()) {
        var _od = parseInt(this.seriova_cisla_hromadne_od);
        var _do = parseInt(this.seriova_cisla_hromadne_do);
        while (_od <= _do) {
          this.seriova_cisla.splice(this.seriova_cisla.length - 1, 0, {cislo: (_od).toString()});
          _od++;
        }
        this.$nextTick(() => {
          var _dm = parseInt(this.produktItem.dodane_mnozstvi);
          if (this.seriova_cisla.length > _dm && this.seriova_cisla[this.seriova_cisla.length - 1].cislo == "")
            this.seriova_cisla.pop();
        });
        this.seriova_cisla_hromadne_od = null;
        this.seriova_cisla_hromadne_do = null;
      }
    },
    saveSeriovaCisla () {
      this.nova_prijemka_produkty[this.nova_prijemka_produkty.indexOf(this.produktItem)].seriova_cisla.clear();
      for (var $i = 0; $i < this.seriova_cisla.length; $i++)
        if (this.seriova_cisla[$i].cislo != null && this.seriova_cisla[$i].cislo.length > 0)
          this.nova_prijemka_produkty[this.nova_prijemka_produkty.indexOf(this.produktItem)].seriova_cisla.push(this.seriova_cisla[$i].cislo);
      this.dialogSeriovaCisla = false;
    },
    removeClick (i) {
      if(this.seriova_cisla.length == 0 || this.seriova_cisla.indexOf(i) == this.seriova_cisla.length - 1) {
        this.seriova_cisla.push({cislo: ''})
      }
      this.seriova_cisla.splice(this.seriova_cisla.indexOf(i), 1);
    },
    inputSerioveCislo (v) {
      if (this.seriova_cisla.indexOf(v) == this.seriova_cisla.length - 1 && v.cislo != null && v.cislo.toString().length > 0 && this.seriova_cisla.length < parseInt(this.produktItem.dodane_mnozstvi)) {
        this.seriova_cisla.push({cislo: ''});
      }
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Sklady/PrijemkaObjednavkyDodavatele.vue